﻿/* PDP â€” gallery + variant picker */
(function () {
  function initGallery(root) {
    const track = root.querySelector('[data-gallery-track]');
    if (!track) return;
    if (track.dataset.galleryBound) return;
    track.dataset.galleryBound = '1';
    const dots = root.querySelectorAll('[data-gallery-dots] [data-dot]');
    const prev = root.querySelector('[data-gallery-prev]');
    const next = root.querySelector('[data-gallery-next]');

    function active() {
      return Math.round(track.scrollLeft / track.clientWidth);
    }
    function go(idx) {
      track.scrollTo({ left: idx * track.clientWidth, behavior: 'smooth' });
    }
    track.addEventListener('scroll', () => {
      const idx = active();
      dots.forEach((d, i) => d.classList.toggle('is-active', i === idx));
    }, { passive: true });
    dots.forEach((d, i) => d.addEventListener('click', () => go(i)));
    if (prev) prev.addEventListener('click', () => go(Math.max(0, active() - 1)));
    if (next) next.addEventListener('click', () => go(active() + 1));

    // Layout "principal + 2 debajo": la fila inferior tiene su propio scroll y flechas.
    const rest = root.querySelector('[data-gallery-rest]');
    const restPrev = root.querySelector('[data-gallery-rest-prev]');
    const restNext = root.querySelector('[data-gallery-rest-next]');
    if (rest) {
      const page = (dir) => rest.scrollBy({ left: dir * rest.clientWidth, behavior: 'smooth' });
      if (restPrev) restPrev.addEventListener('click', () => page(-1));
      if (restNext) restNext.addEventListener('click', () => page(1));
    }

    // La ficha debe abrirse siempre en la primera imagen. Los navegadores
    // moviles (iOS Safari sobre todo, con bfcache) restauran el scroll
    // horizontal del carrusel al volver atras o al recuperar la pagina, y el
    // producto aparecia abierto en una de las ultimas fotos. Forzamos la 0
    // mientras el usuario no haya tocado la galeria.
    let userMoved = false;
    const markMoved = () => { userMoved = true; };
    ['pointerdown', 'touchstart', 'wheel', 'keydown'].forEach((evt) => {
      track.addEventListener(evt, markMoved, { passive: true });
    });
    dots.forEach((d) => d.addEventListener('click', markMoved));
    [prev, next, restPrev, restNext].forEach((btn) => {
      if (btn) btn.addEventListener('click', markMoved);
    });

    function jumpToStart(el) {
      if (!el || el.scrollLeft === 0) return;
      const previous = el.style.scrollBehavior;
      el.style.scrollBehavior = 'auto';
      el.scrollLeft = 0;
      requestAnimationFrame(() => { el.style.scrollBehavior = previous; });
    }

    function resetToFirst() {
      if (userMoved) return;
      jumpToStart(track);
      jumpToStart(rest);
      dots.forEach((d, i) => d.classList.toggle('is-active', i === 0));
    }

    // Se repite porque el desplazamiento puede llegar tarde: al restaurar la
    // pagina, al terminar de cargar las imagenes o al asentarse el layout.
    resetToFirst();
    requestAnimationFrame(resetToFirst);
    window.addEventListener('load', resetToFirst);
    window.addEventListener('pageshow', resetToFirst);
    setTimeout(resetToFirst, 250);
    setTimeout(resetToFirst, 800);
  }

  function initVariantPicker(form, root) {
    const variantsEl = root.querySelector('[data-product-json]');
    if (!variantsEl) return;
    let variants;
    try { variants = JSON.parse(variantsEl.textContent); } catch (e) { return; }
    if (!Array.isArray(variants)) return;

    const variantInput = form.querySelector('[data-variant-id]');
    const variantSelect = form.querySelector('[data-variant-select]');
    const priceWrap = root.querySelector('[data-price]');
    const atc = form.querySelector('[data-add-to-cart]');
    const atcText = form.querySelector('[data-atc-text]');
    const labels = {
      addToCart: root.dataset.labelAddToCart || 'Add to cart',
      soldOut: root.dataset.labelSoldOut || 'Sold out',
      unavailable: root.dataset.labelUnavailable || 'Unavailable'
    };

    function selectedOptions() {
      if (variantSelect) {
        const variant = variants.find((v) => String(v.id) === String(variantSelect.value));
        return variant ? variant.options : [];
      }
      const inputs = form.querySelectorAll('input[name^="options["]:checked');
      return Array.from(inputs).map((i) => i.value);
    }
    function findVariant(opts) {
      if (!opts.length && variantInput) {
        return variants.find((v) => String(v.id) === String(variantInput.value)) || variants[0] || null;
      }
      return variants.find((v) => v.options.every((o, i) => o === opts[i])) || null;
    }
    function updateLabels() {
      // For each option group, update the selected value display + active states
      const groups = form.querySelectorAll('[name^="options["]');
      const seen = new Set();
      groups.forEach((input) => {
        const groupName = input.name;
        if (seen.has(groupName)) return;
        seen.add(groupName);
        // Active class on parent label
        form.querySelectorAll(`[name="${groupName}"]`).forEach((i) => {
          const label = i.closest('label');
          if (label) label.classList.toggle('is-active', i.checked);
        });
      });
    }
    function update() {
      const opts = selectedOptions();
      const variant = findVariant(opts);
      updateLabels();

      if (!variant) {
        document.dispatchEvent(new CustomEvent('pdp:variant-change', { detail: { variant: null } }));
        atc.disabled = true;
        atcText.textContent = labels.unavailable;
        return;
      }
      variantInput.value = variant.id;
      if (variantSelect && String(variantSelect.value) !== String(variant.id)) {
        variantSelect.value = variant.id;
      }

      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());

      // Update price
      if (priceWrap) {
        const money = (cents) => {
          const n = (cents / 100).toFixed(2).replace('.', ',');
          return `${n} €`;
        };
        // Descuento automático de colección (custom.descuento_flash), mismo cálculo que en Liquid.
        // Las colecciones con fechas vienen en data-flash-sched ("pct|inicio|fin;..."): gana el mayor vigente.
        let flashPct = parseInt(priceWrap.getAttribute('data-flash-pct') || '0', 10);
        const now = Date.now() / 1000;
        (priceWrap.getAttribute('data-flash-sched') || '').split(';').forEach((item) => {
          const [pct, start, end] = item.split('|');
          if ((Number(start) || -Infinity) <= now && now <= (Number(end) || Infinity)) {
            flashPct = Math.max(flashPct, Number(pct) || 0);
          }
        });
        const onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
        if (flashPct > 0) {
          const salePrice = variant.price - Math.round(variant.price * flashPct / 100);
          const compare = onSale ? variant.compare_at_price : variant.price;
          priceWrap.innerHTML = `<span class="pdp__price-sale">${money(salePrice)}</span><span class="pdp__price-compare">${money(compare)}</span>`;
        } else if (onSale) {
          priceWrap.innerHTML = `<span class="pdp__price-sale">${money(variant.price)}</span><span class="pdp__price-compare">${money(variant.compare_at_price)}</span>`;
        } else {
          priceWrap.innerHTML = `<span class="pdp__price-regular">${money(variant.price)}</span>`;
        }
      }

      const dynamic = form.querySelector('[data-dynamic-checkout]');
      if (dynamic) {
        const min = Number(dynamic.dataset.dynamicMin || 0);
        dynamic.hidden = !variant.available || variant.price < min;
      }

      document.dispatchEvent(new CustomEvent('pdp:variant-change', { detail: { variant } }));

      if (variant.available) {
        atc.disabled = false;
        atc.classList.remove('is-sold-out');
        atcText.textContent = labels.addToCart;
      } else {
        atc.disabled = true;
        atc.classList.add('is-sold-out');
        atcText.textContent = labels.soldOut;
      }
    }

    form.addEventListener('change', (e) => {
      if (e.target.matches('input[name^="options["], [data-variant-select]')) update();
    });
    updateLabels();
    update();
  }

  function initMobileBuySticky(root) {
    const buy = root.querySelector('[data-buy-section]');
    if (!buy || buy.dataset.stickyBound === 'true') return;

    buy.dataset.stickyBound = 'true';

    const mobileMax = 749;
    let spacer = root.querySelector('[data-buy-spacer]');

    if (!spacer) {
      spacer = document.createElement('div');
      spacer.className = 'pdp__buy-spacer';
      spacer.setAttribute('data-buy-spacer', 'true');
      root.appendChild(spacer);
    }

    let rafId = null;

    function isMobile() {
      return window.innerWidth <= mobileMax;
    }

    function updateViewportOffset() {
      let bottomOffset = 0;

      if (window.visualViewport) {
        bottomOffset = Math.max(
          0,
          Math.round(window.innerHeight - window.visualViewport.height - window.visualViewport.offsetTop)
        );
      }

      buy.style.setProperty('--pdp-mobile-viewport-offset', `${bottomOffset}px`);
    }

    function syncSpacer() {
      if (!isMobile()) {
        spacer.style.height = '0px';
        return;
      }

      spacer.style.height = buy.classList.contains('is-stuck')
        ? `${Math.ceil(buy.getBoundingClientRect().height)}px`
        : '0px';
    }

    // En móvil el bloque de compra se queda en su sitio (en el flujo) mientras se ve y pasa a ser
    // una barra fija abajo cuando se sale de pantalla. El hueco evita que la página salte.
    const holder = document.createElement('div');
    holder.className = 'pdp__buy-holder';
    buy.parentNode.insertBefore(holder, buy);
    holder.appendChild(buy);

    let inView = false;

    function measureNatural() {
      const wasStuck = buy.classList.contains('is-stuck');
      buy.classList.remove('is-stuck', 'is-sticky-active');
      const height = Math.ceil(buy.getBoundingClientRect().height);
      if (wasStuck) buy.classList.add('is-stuck', 'is-sticky-active');
      return height;
    }

    function tick() {
      rafId = null;

      if (!isMobile()) {
        buy.style.removeProperty('--pdp-mobile-viewport-offset');
        buy.classList.remove('is-stuck', 'is-sticky-active');
        holder.style.minHeight = '';
        spacer.style.height = '0px';
        return;
      }

      updateViewportOffset();
      const stuck = !inView;
      if (stuck) {
        holder.style.minHeight = `${measureNatural()}px`;
      } else {
        holder.style.minHeight = '';
      }
      buy.classList.toggle('is-stuck', stuck);
      buy.classList.toggle('is-sticky-active', stuck);
      syncSpacer();
    }

    if ('IntersectionObserver' in window) {
      new IntersectionObserver((entries) => {
        inView = entries[0].isIntersecting;
        schedule();
      }).observe(holder);
    } else {
      inView = false;
    }

    function schedule() {
      if (rafId !== null) return;
      rafId = requestAnimationFrame(tick);
    }

    schedule();

    window.addEventListener('resize', schedule, { passive: true });
    window.addEventListener('orientationchange', schedule);
    window.addEventListener('load', schedule);

    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', schedule);
      window.visualViewport.addEventListener('scroll', schedule);
    }

    if ('ResizeObserver' in window) {
      const observer = new ResizeObserver(schedule);
      observer.observe(buy);
    }
  }

  function initAccordionLinks(root) {
    root.querySelectorAll('[data-accordion-trigger]').forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        const target = document.getElementById(btn.dataset.accordionTrigger);
        if (target && target.tagName === 'DETAILS') {
          target.open = true;
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });
  }

  function initKiwiSizeChart(root) {
    const chart = root.querySelector('#kiwi-size-chart, .pdp__kiwi-size-chart');
    const host = root.querySelector('[data-kiwi-size-host]');
    const fallbackTrigger = host ? host.querySelector('[data-kiwi-size-trigger]') : null;

    function findOpener() {
      const scopes = [chart, root, document].filter(Boolean);
      for (const scope of scopes) {
        const candidates = scope.querySelectorAll('a, button, [role="button"], [class*="kiwi"], [class*="Kiwi"], [id*="kiwi"], [id*="Kiwi"], [class*="ks-"], [id*="ks-"]');
        for (const el of candidates) {
          if (el === fallbackTrigger) continue;
          const text = (el.textContent || '').trim().toLowerCase();
          const marker = `${el.className || ''} ${el.id || ''}`.toLowerCase();
          if (text.includes('size chart') || text.includes('size guide') || text.includes('guía') || marker.includes('kiwi') || marker.includes('ks-')) {
            return el;
          }
        }
      }
      return null;
    }

    function prepareOpener(opener) {
      opener.textContent = root.dataset.labelSizeGuide || 'Size guide';
      opener.classList.add('pdp__kiwi-opener-source');
      opener.setAttribute('data-kiwi-opener-source', 'true');
    }

    function mountOpener() {
      const opener = findOpener();
      if (!opener || !host) return;
      prepareOpener(opener);
      if (chart) chart.classList.add('pdp__kiwi-size-chart--ready');
    }

    if (fallbackTrigger && !fallbackTrigger.dataset.kiwiTriggerBound) {
      fallbackTrigger.dataset.kiwiTriggerBound = 'true';
      fallbackTrigger.addEventListener('click', (e) => {
        e.preventDefault();
        mountOpener();
        const opener = findOpener();
        if (opener && opener !== fallbackTrigger) opener.click();
      });
    }

    if (chart && !chart.dataset.kiwiObserverBound) {
      chart.dataset.kiwiObserverBound = 'true';
      mountOpener();
      const localize = () => mountOpener();
      const observer = new MutationObserver(localize);
      observer.observe(chart, { childList: true, subtree: true, characterData: true });
      setTimeout(mountOpener, 500);
      setTimeout(mountOpener, 1500);
    }
  }

  function initPaymentOptions(root) {
    const container = root.querySelector('[data-dynamic-checkout]');
    const labelSource = container && container.querySelector('[data-more-options-label]');
    if (!container || !labelSource) return;

    const label = (labelSource.textContent || '').trim();
    if (!label) return;

    function localize() {
      const link = container.querySelector('.shopify-payment-button__more-options');
      if (link && link.textContent.trim() !== label) link.textContent = label;
    }

    localize();
    if (container.dataset.paymentOptionsBound === 'true') return;
    container.dataset.paymentOptionsBound = 'true';
    new MutationObserver(localize).observe(container, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }

  function init() {
    const sections = document.querySelectorAll('.pdp');
    sections.forEach((root) => {
      initGallery(root);
      const form = root.querySelector('[data-pdp-form]');
      if (form) initVariantPicker(form, root);
      initMobileBuySticky(root);
      initAccordionLinks(root);
      initKiwiSizeChart(root);
      initPaymentOptions(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
